import moment from "moment";
moment.locale("pt-BR");

const deepClone = (element) => JSON.parse(JSON.stringify(element));

export function handleAlert(message, type, fixed, timeout) {
  this.$root.$emit("alert", message, type, fixed, timeout);
}

export function fetchTotalPages(total, limit = 15) {
  let value = total / limit;
  if (value % 1 !== 0) value = value + 1;

  return Math.trunc(value);
}

export function formatDate(date, format = "DD/MM/YYYY HH:mm:ss", origin = "") {
  if (!date) return null;
  return moment(date, origin).format(format);
}

const mapItemSelectorElement = (element, { itemValue, itemText }) => ({
  [itemValue]: element[itemValue],
  [itemText]: element[itemText],
});

export function processItemSelectorData(section, data = [], options = {}) {
  const { override = false } = options;
  const keys = {
    itemValue: section.itemValue || "_id",
    itemText: section.itemText || "name",
  };

  const selected = [];

  if (section.multiple) {
    if (section.selected?.length) {
      selected.push(...section.selected);
    }
  } else if (section.selected?.[keys.itemValue]) {
    selected.push(section.selected);
  }

  if (data.length > 0) {
    const items = [
      ...selected,
      ...data.map((e) => mapItemSelectorElement(e, keys)),
    ];
    if (override) {
      section.data = items;
    } else {
      section.data.push(...items);
    }
  }

  return section;
}

export function processItemSelectorInitialData(section, selected) {
  const keys = {
    itemValue: section.itemValue || "_id",
    itemText: section.itemText || "name",
  };

  section.page = 0;
  section.count = 0;
  section.loading = false;
  section.raw = [];
  section.data = [];

  if (section.multiple) {
    section.selected = [];
    if (Array.isArray(selected)) {
      const items = selected.map((e) => mapItemSelectorElement(e, keys));
      section.data.push(...deepClone(items));
      section.selected.push(...deepClone(items));
    } else {
      const item = mapItemSelectorElement(selected, keys);
      section.data.push(deepClone(item));
      section.selected.push(deepClone(item));
    }
  } else {
    const item = mapItemSelectorElement(selected, keys);
    section.data.push(deepClone(item));
    section.selected = deepClone(item);
  }

  return section;
}

export function getStartOfMinute(date) {
  return moment(date).startOf("minute");
}

export function getEndOfMinute(date) {
  return moment(date).endOf("minute");
}

export function formatISODate(
  date,
  format = "YYYY-MM-DDTHH:mm:ssZ",
  inputFormat = null
) {
  if (!date) return null;

  let parsed;

  if (inputFormat) parsed = moment(date, inputFormat, true);
  else parsed = moment(date);

  return parsed.isValid() ? parsed.format(format) : null;
}

export { deepClone };

export function preventOnlyNumber(event) {
  event = event ? event : window.event;
  let charCode = event.which ? event.which : event.keyCode;

  if (charCode < 48 || charCode > 57) return event.preventDefault();
  else true;
}

export function formatIdentification(documentType, document) {
  if (documentType === "MP") return "MP";
  if (!document) return "--";

  // Registros anteriores a essa feature só tinham `cpf`, sem `documentType` —
  // como só CPF era coletado antes, assume-se CPF nesse caso.
  return `${documentType || "CPF"} ${document}`;
}

export function validateCpf(cpf) {
  cpf = cpf.replace(/\D/g, "");
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const calcDigito = (fator) =>
    ((cpf
      .slice(0, fator - 1)
      .split("")
      .reduce((soma, num, i) => soma + num * (fator - i), 0) *
      10) %
      11) %
    10;

  return calcDigito(10) == cpf[9] && calcDigito(11) == cpf[10];
}

// Desde a mudança da Receita Federal para CNPJ alfanumérico, as 12 primeiras
// posições podem ser letra ou número — só os 2 dígitos verificadores finais
// continuam numéricos. O valor de cada caractere é `charCode - 48` (dígitos
// '0'-'9' viram 0-9, letras 'A'-'Z' viram 17-42), conforme o algoritmo oficial.
export function validateCnpj(cnpj) {
  cnpj = cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
  if (cnpj.length !== 14 || /^(.)\1{13}$/.test(cnpj)) return false;

  const charValue = (char) => char.charCodeAt(0) - 48;

  const calcDigito = (length) => {
    const numbers = cnpj.substring(0, length);
    let sum = 0;
    let pos = length - 7;

    for (let i = 0; i < length; i += 1) {
      sum += charValue(numbers[i]) * pos;
      pos = pos > 2 ? pos - 1 : 9;
    }

    return sum % 11 < 2 ? 0 : 11 - (sum % 11);
  };

  return calcDigito(12) == cnpj[12] && calcDigito(13) == cnpj[13];
}

// A OAB não possui dígito verificador oficial nacional — valida apenas o
// formato: número de inscrição (3 a 6 dígitos) seguido da seccional (UF).
export function validateOab(oab) {
  oab = oab.replace(/[^\dA-Za-z/]+/g, "").toUpperCase();

  return /^\d{3,6}\/[A-Z]{2}$/.test(oab);
}
